<!-- 列表页表格 -->
<template>
    <div class="reportTable">
        <h1 class="title">{{tableData.title}}</h1>
        <el-table
            :data="tableData.tableData"
            style="width: 100%">
            <el-table-column
                v-for="(head,index) in tableData.tableHead"
                :key="index"
                :prop="head.prop?head.prop:''"
                :label="head.label+(head.unit?('('+head.unit+')'):'')"
                align="center"
                :render-header="labelHead">
                <template v-if="head.children&&head.children.length">
                    <el-table-column
                        v-for="(item,idx) in head.children"
                        :key="idx"
                        :prop="item.prop?item.prop:''"
                        :label="item.label"
                        align="center"
                        :render-header="labelHead">
                    </el-table-column>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import Util from '@/utils/Util';
export default {
    data() {
        return {
            dpr:Util.setDpr(),
        }
    },
    props:{
        tableData:{
            default(){
                return {};
            }
        },
    },
    methods: {
        labelHead(h, {column,$index}) {
            // console.log(h, column,$index)
            // 处理方案一 根据 label 字符长度设置宽度 
            // let l = column.label.length
            // let f = 16 //每个字大小，其实是每个字的比例值，大概会比字体大小差不多大一点，
            // column.minWidth = f * l + 40 //字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度
            // 处理方案二 针对性的设置宽度
            // if(column.label=='序号'){
            //     column.minWidth = 50 * this.dpr
            // }

            return h('span', {
                attrs: {
                    class: 'table-head',
                    title: column.label
                },
                
            }, [column.label])
        },
    },
}
</script>

<style lang="scss">
.reportTable{
    .title{
        text-align: center;
        font-size: .16rem;
        color: #1D2531;
        height: .4rem;
        line-height: .4rem;
        margin-bottom: .1rem;
    }
    .el-table{
        color:#222933;

        thead{
            &.is-group,&.has-gutter{
                th{
                    background: rgba($color: #C32C2F, $alpha: 0.7);
                    color: white;
                }
            }
        }

        tbody{
            tr{
                background: rgba($color: #C5C6CB, $alpha: 0.2);
                &:nth-child(2n){
                    background: white;
                }
            }

            td{
                padding: .1rem 0;
            }
        }
    }
    .el-table--border td,
    .el-table--border th,
    .el-table__body-wrapper
    .el-table--border.is-scrolling-left~.el-table__fixed {
        border: none;
    }
    .el-table--border, .el-table--group{
        border:none;
    }
    .el-table--border::after, .el-table--group::after{
        width: 0;
    } 
}
</style>
